// Global API client with auth handling
export const apiClient = {
  async request(url: string, options: RequestInit = {}) {
    const response = await fetch(url, {
      ...options,
      credentials: "include",
    });

    if (response.status === 401) {
      window.dispatchEvent(new Event("unauthorized"));
      return;
    }

    return response;
  },

  async get(url: string) {
    return this.request(url, { method: "GET" });
  },

  async post(url: string, data?: any) {
    return this.request(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: data ? JSON.stringify(data) : undefined,
    });
  },
};
